import React, { Component, Fragment } from "react";
import {
  shuffle,
  isEqual,
  filter,
  // sum,
  concat,
  indexOf,
} from "lodash";
import "./MIXTypeQuestion.scss";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import $ from "jquery";
// import okButtonIcon from "../../../../assets/images/okbutton_icon.png";
// import FlipMove from "react-flip-move";

//-----------------------------------------------------------------------------
// Unscramble Question Type - MIX
//-----------------------------------------------------------------------------
class MIXTypeQuestion extends Component {
  constructor() {
    super();
    this.state = {
      generatedAnswers: [],
      disableFlipMove: false,
      currentQuestionScorePercentage: 0,
      generatedAnswer: {},
      panning: true,
      currentTriesCount: 2,
    };
  }

  componentDidMount() {
    const { currentQuestion } = this.props;
    this.generateAnswersSet(
      currentQuestion.AData,
      currentQuestion.IsRandomAnswers,
      currentQuestion.QTypeShort,
      currentQuestion.ADataRandomLines,
      currentQuestion.AExtraData
    );
    window.document.body.addEventListener(
      "touchmove",
      this.handlePreventTouchmoveWhenPanning,
      {
        passive: false,
      }
    );
  }

  handlePreventTouchmoveWhenPanning = (event) => {
    if (this.state.panning) {
      event.preventDefault();
    }
  };

  componentWillUnmount() {
    window.document.body.removeEventListener(
      "touchmove",
      this.handlePreventTouchmoveWhenPanning,
      {
        passive: false,
      }
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentQuestion !== nextProps.currentQuestion) {
      this.generateAnswersSet(
        nextProps.currentQuestion.AData,
        nextProps.currentQuestion.IsRandomAnswers,
        nextProps.currentQuestion.QTypeShort,
        nextProps.currentQuestion.ADataRandomLines,
        nextProps.currentQuestion.AExtraData
      );
    }
  }

  generateAnswersSet = (
    answerData,
    isRandomAnswers,
    questionType,
    randomLinesCount,
    extraData
  ) => {
    let generatedAnswersArray = [];

    generatedAnswersArray = filter(answerData.split("\n")).map(
      (item, index) => {
        let splittedArray = item.split("|");
        return splittedArray;
      }
    );

    generatedAnswersArray = this.props.getRandomAnswers(
      filter(generatedAnswersArray),
      randomLinesCount
    );

    let randomSelectedData = generatedAnswersArray[0];
    let generatedAnswer = {
      id: 1,
      rawQuestion: randomSelectedData[1],

      answersData: randomSelectedData[2].split("<BR />"),
      extraLettersData: extraData.trim().split(""),
    };

    // Set the question
    this.props.setQuizQuestion(
      this.unscrambleQuestionFormatter(generatedAnswer.rawQuestion)
    );
    generatedAnswer.correctScrambleLettersList = generatedAnswer.answersData.map(
      (item, index) => {
        let lettersList = [...item.trim()].map((letter, letterIndex) => {
          return letter === "_" ? " " : letter;
        });

        return filter(lettersList);
      }
    );
    generatedAnswer.blankScrambleLettersList = generatedAnswer.correctScrambleLettersList.map(
      (item, index) => {
        return item.map((letter, letterIndex) => {
          return letter === " " ? letter : "_";
        });
      }
    );
    let allLettersList = [];

    generatedAnswer.answersData.forEach((element) => {
      let singleLetters = element.trim().split("");
      singleLetters.forEach((letterElement) => {
        if (letterElement !== "_") {
          allLettersList.push(letterElement);
        }
      });
    });

    // Merge extra letters
    // Remember: shuffle or sort based on passed in randomize parameter
    if (isRandomAnswers === "1") {
      allLettersList = shuffle(
        concat(allLettersList, generatedAnswer.extraLettersData)
      );  
    } else {
      allLettersList = concat(allLettersList, generatedAnswer.extraLettersData);
      allLettersList.sort();
    }
    allLettersList = allLettersList.map((element, index) => ({
      id: index + 1,
      letter: element,
    }));
    generatedAnswer.allLettersList = allLettersList;

    generatedAnswersArray.forEach((listItem, index) => {
      listItem.optionActualOrder = index + 1;
    });
    this.setState({
      generatedAnswer: generatedAnswer,
    });
  };

  verifyUnscrambleAnswer = () => {
    const {
      blankScrambleLettersList,
      correctScrambleLettersList,
      rawQuestion,
    } = this.state.generatedAnswer;
    const { currentQuestionScorePercentage, currentTriesCount } = this.state;
    let { currentQuestion, currentQuestionId } = this.props;
    let isPuzzleAnswerCorrect = isEqual(
      blankScrambleLettersList,
      correctScrambleLettersList
    );

    if (isPuzzleAnswerCorrect) {
      let questionDetails = {
        number: currentQuestionId,
        questionText: this.unscrambleQuestionFormatter(rawQuestion),
        QTypeShort: currentQuestion.QTypeShort,
        questionGraphicUrl: currentQuestion.QGraphicURL,
        correctAnswersCount: 1,
        expectedAnswersCount: 1,
        answers: [],
        deductionPercentage: currentQuestionScorePercentage,
        isCorrect: 1,
      };

      this.props.addAttendedQuestion(questionDetails);
      this.setState({
        currentQuestionScorePercentage: 0,
        currentTriesCount: 2,
      });
    } else {
      if (currentQuestionScorePercentage < 100) {
        //deduct from total points and allow to try again -  total 4 tries
        //1st try - 0 deduction - 100% point
        //2nd try - 50% deduction - 50% point
        //3rd try - 75% deduction
        //4th try - 100% deduction
        this.setState({
          currentQuestionScorePercentage:
            currentTriesCount === 1 ? 0 : currentTriesCount * 25,
          currentTriesCount: currentTriesCount + 1,
        });
      } else {
        // all tries completed, give scores for this question and move to next question
        let questionDetails = {
          number: currentQuestionId,
          questionText: this.unscrambleQuestionFormatter(rawQuestion),
          QTypeShort: currentQuestion.QTypeShort,
          questionGraphicUrl: currentQuestion.QGraphicURL,
          correctAnswersCount: 1,
          expectedAnswersCount: 1,
          answers: blankScrambleLettersList,
          deductionPercentage: currentQuestionScorePercentage,
          isCorrect: 0,
        };

        this.props.addAttendedQuestion(questionDetails);
        this.setState({
          currentQuestionScorePercentage: 0,
          currentTriesCount: 2,
        });
      }
    }
  };

  unscrambleQuestionFormatter = (rawQuestion) => {
    return rawQuestion.split("<BR />").map((item, key) => {
      item = item.replace(
        new RegExp("<BLANKSHORT>", "g"),
        "<span style='text-decoration: underline;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>"
      );
      item = item.replace(
        new RegExp("<BLANKMEDIUM>", "g"),
        "<span style='text-decoration: underline;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>"
      );
      item = item.replace(
        new RegExp("<BLANKLONG>", "g"),
        "<span style='text-decoration: underline;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>"
      );
      return (
        <Fragment key={key}>
          <span dangerouslySetInnerHTML={{ __html: item }}></span>
          <br />
        </Fragment>
      );
    });
  };

  reorderList = (list, startIndex, endIndex) => {
    const [removed] = list.splice(startIndex, 1);
    list.splice(endIndex, 0, removed);
    list.forEach((listItem, index) => {
      listItem.optionActualOrder = index + 1;
    });
    return list;
  };

  getRemainingTriesText = () => {
    switch (this.state.currentQuestionScorePercentage) {
      case 50:
        return "3 Attempts Remaining";
      case 75:
        return "2 Attempts Remaining";
      case 100:
        return "1 Attempt Remaining";
      default:
        return "";
    }
  };

  onDragEnd = (data) => {
    if (data.destination) {
      if (data.destination.droppableId !== "droppable-2") {
        let {
          blankScrambleLettersList,
          allLettersList,
        } = this.state.generatedAnswer;

        const destinationDetails = data.destination.droppableId.split("_");
        const destinationDropIndex1 = destinationDetails[1];
        const destinationDropIndex2 = destinationDetails[2];
        const sourceDetails = data.draggableId.split("_");
        const sourceName = sourceDetails[0];
        if (sourceName === "droppable-draggable") {
          // drag letter to overlap
          const sourceDragLetterIndex1 = sourceDetails[1];
          const sourceDragLetterIndex2 = sourceDetails[2];
          if (
            blankScrambleLettersList[destinationDropIndex1][
              destinationDropIndex2
            ] === "_"
          ) {
            //replace letter in blank space
            blankScrambleLettersList[destinationDropIndex1][
              destinationDropIndex2
            ] =
              blankScrambleLettersList[sourceDragLetterIndex1][
                sourceDragLetterIndex2
              ];
            blankScrambleLettersList[sourceDragLetterIndex1][
              sourceDragLetterIndex2
            ] = "_";
          } else {
            //swap letter when overlap on existing letter
            const swappingLetter =
              blankScrambleLettersList[destinationDropIndex1][
                destinationDropIndex2
              ];
            blankScrambleLettersList[destinationDropIndex1][
              destinationDropIndex2
            ] =
              blankScrambleLettersList[sourceDragLetterIndex1][
                sourceDragLetterIndex2
              ];
            blankScrambleLettersList[sourceDragLetterIndex1][
              sourceDragLetterIndex2
            ] = "_";
            allLettersList.push({
              id: allLettersList.length + 1,
              letter: swappingLetter,
            });
          }
          $(
            "#droppable_" +
              sourceDragLetterIndex1 +
              "_" +
              sourceDragLetterIndex2
          ).removeClass("bottom-border-item");
        } else {
          //drag letter from all letters list
          const sourceDragLetterIndex = sourceDetails[1];
          if (
            blankScrambleLettersList[destinationDropIndex1][
              destinationDropIndex2
            ] !== "_"
          ) {
            //drag n drop letter on existing letter
            let swappingExistingLetter =
              blankScrambleLettersList[destinationDropIndex1][
                destinationDropIndex2
              ];
            blankScrambleLettersList[destinationDropIndex1][
              destinationDropIndex2
            ] = allLettersList[sourceDragLetterIndex].letter;
            allLettersList[
              sourceDragLetterIndex
            ].letter = swappingExistingLetter;
          } else {
            //drag n drop letter to blank space
            blankScrambleLettersList[destinationDropIndex1][
              destinationDropIndex2
            ] = allLettersList[sourceDragLetterIndex].letter;
            allLettersList.splice(sourceDragLetterIndex, 1);
          }
        }
        this.setState(
          {
            generatedAnswer: {
              ...this.state.generatedAnswer,
              blankScrambleLettersList,
              allLettersList,
            },
          },
          () => {
            this.props.setPuzzleStatus(true);
            this.checkAnswerCompleted();
          }
        );
      }
    } else {
      const sourceDetails = data.draggableId.split("_");
      const sourceDragLetterIndex1 = sourceDetails[1];
      const sourceDragLetterIndex2 = sourceDetails[2];
      $(
        "#droppable_" + sourceDragLetterIndex1 + "_" + sourceDragLetterIndex2
      ).removeClass("bottom-border-item");
    }
  };

  checkAnswerCompleted = () => {
    let { blankScrambleLettersList } = this.state.generatedAnswer;
    let blankIndex = "";
    blankScrambleLettersList.every((blankLetterRow, rowIndex) => {
      blankIndex = indexOf(blankLetterRow, "_");
      if (blankIndex !== -1) {
        blankIndex = rowIndex;
        return false;
      } else {
        return true;
      }
    });
    if (blankIndex === -1 || blankIndex === "") {
      this.verifyUnscrambleAnswer();
    }
  };

  onDragStart = (data) => {
    if (data.draggableId) {
      const sourceDetails = data.draggableId.split("_");
      const sourceName = sourceDetails[0];
      if (sourceName === "droppable-draggable") {
        const sourceDragLetterIndex1 = sourceDetails[1];
        const sourceDragLetterIndex2 = sourceDetails[2];
        //Add border when existing letter starts dragging
        $(
          "#droppable_" + sourceDragLetterIndex1 + "_" + sourceDragLetterIndex2
        ).addClass("bottom-border-item");
      }
    }
  };

  onClickLetter = (letterIndex) => {
    let {
      blankScrambleLettersList,
      allLettersList,
    } = this.state.generatedAnswer;
    let firstBlankIndex = "";
    let letterRowIndex = "";
    blankScrambleLettersList.every((blankLetterRow, rowIndex) => {
      firstBlankIndex = indexOf(blankLetterRow, "_");
      if (firstBlankIndex !== -1) {
        letterRowIndex = rowIndex;
        return false;
      } else {
        return true;
      }
    });
    if (firstBlankIndex !== "" && firstBlankIndex !== -1) {
      //empty space available to drop letter
      blankScrambleLettersList[letterRowIndex][firstBlankIndex] =
        allLettersList[letterIndex].letter;
      allLettersList.splice(letterIndex, 1);
      this.setState(
        {
          generatedAnswer: {
            ...this.state.generatedAnswer,
            blankScrambleLettersList,
            allLettersList,
          },
        },
        () => {
          this.props.setPuzzleStatus(true);
          this.checkAnswerCompleted();
        }
      );
    } else {
      // no space available for drop letter
      this.props.setPuzzleStatus(true);
      this.verifyUnscrambleAnswer();
    }
  };

  render() {
    const { generatedAnswer } = this.state;
    const remainingTriesText = this.getRemainingTriesText();
    return (
      <div className="answer-options-container unscramble-puzzle-container">
        {remainingTriesText && (
          <div className="remaining-attempts-text">{remainingTriesText}</div>
        )}
        {generatedAnswer && (
          <div className="mix-data-container">
            <DragDropContext
              onDragEnd={this.onDragEnd}
              onDragStart={this.onDragStart}
            >
              <div className="blanks-list-container">
                {generatedAnswer.blankScrambleLettersList &&
                  generatedAnswer.blankScrambleLettersList.map(
                    (singleLetterRow, rowIndex) => {
                      return (
                        <Fragment key={"row_" + rowIndex}>
                          <div className="blank-space-container">
                            {singleLetterRow.map((item, index) => {
                              return item === " " ? (
                                <div
                                  className={
                                    "single-blank-item empty-space-item"
                                  }
                                  key={rowIndex + "_" + index}
                                ></div>
                              ) : (
                                <Droppable
                                  droppableId={
                                    "droppable_" + rowIndex + "_" + index
                                  }
                                  key={rowIndex + "_" + index}
                                >
                                  {(provided1, snapshot) => (
                                    <div ref={provided1.innerRef}>
                                      {
                                        <div
                                          className={
                                            "single-blank-item " +
                                            (item === "_"
                                              ? "bottom-border-item"
                                              : "")
                                          }
                                          id={
                                            "droppable_" +
                                            rowIndex +
                                            "_" +
                                            index
                                          }
                                        >
                                          <Draggable
                                            draggableId={
                                              "droppable-draggable_" +
                                              rowIndex +
                                              "_" +
                                              index
                                            }
                                            key={index}
                                            index={index}
                                          >
                                            {(provided, snapshot) => (
                                              <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className={
                                                  item !== "_"
                                                    ? "single-letter-item margin-0"
                                                    : ""
                                                }
                                              >
                                                {item !== "_" ? item : " "}
                                              </div>
                                            )}
                                          </Draggable>
                                        </div>
                                      }
                                      <div style={{ display: "none" }}>
                                        {provided1.placeholder}
                                      </div>
                                    </div>
                                  )}
                                </Droppable>
                              );
                            })}
                          </div>
                          <br />
                        </Fragment>
                      );
                    }
                  )}
              </div>
              <div className="option-letters-container">
                <Droppable
                  droppableId="droppable-2"
                  isDropDisabled={true}
                  direction="horizontal"
                >
                  {(provided2, snapshot) => (
                    <div ref={provided2.innerRef} className="letters-list">
                      {generatedAnswer.allLettersList &&
                        generatedAnswer.allLettersList.map((element, index) => {
                          return (
                            <Draggable
                              draggableId={"draggable_" + index}
                              key={index}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className="single-letter-item"
                                  onClick={() => this.onClickLetter(index)}
                                >
                                  {element.letter}
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                      {provided2.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </DragDropContext>
          </div>
        )}
      </div>
    );
  }
}

export default MIXTypeQuestion;
